import { useQuery } from '@apollo/client'

import { GTCompanyLineAutocomplete, GTCompanyLinesAutocompleteInput } from 'gql/types.generated'
import { GET_COMPANY_LINES_AUTOCOMPLETE } from './queries-legacy'
import { ICompanyLinesAutocompleteQueryInput, ICompanyLinesAutocompleteQueryOutput } from './types'

export const useCompanyLinesAutocompleteQuery = ({
  companyId,
  skip
}: ICompanyLinesAutocompleteQueryInput = {}): ICompanyLinesAutocompleteQueryOutput => {
  const input: GTCompanyLinesAutocompleteInput = { limit: 1000 }

  if (companyId) {
    input.companyID = companyId
  }

  const { data, loading, error, refetch } = useQuery(GET_COMPANY_LINES_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip,
    variables: {
      input
    }
  })

  return {
    companyLines: data?.companyLinesAutocomplete || [],
    loading,
    error,
    refetch
  }
}

interface IUseCompanyLineAutocompleteOptions {
  skip?: boolean
}

export const useCompanyLineAutocomplete = (
  companyLineId: string,
  { skip }: IUseCompanyLineAutocompleteOptions = {}
): GTCompanyLineAutocomplete | null => {
  const { data } = useQuery<{ companyLinesAutocomplete: GTCompanyLineAutocomplete[] }>(GET_COMPANY_LINES_AUTOCOMPLETE, {
    skip
  })

  return data?.companyLinesAutocomplete?.find((companyLine) => companyLine.id === companyLineId) || null
}
